// Ronsoco email sign-up pop-up (sections/ronsoco-email-popup.liquid).
// Remembers the visitor's answer in this browser: closed = quiet for 30 days, signed up = never again.
(() => {
  if (window.ronsocoEmailPopup) return;

  const KEY = 'ronsoco-email-popup';
  const QUIET_DAYS = 30;
  const DAY = 24 * 60 * 60 * 1000;

  const read = () => {
    try {
      return JSON.parse(localStorage.getItem(KEY) || 'null');
    } catch (e) {
      return null;
    }
  };

  const write = (state) => {
    try {
      localStorage.setItem(KEY, JSON.stringify({ state, at: Date.now() }));
    } catch (e) {}
  };

  const dialog = () => document.getElementById('RonsocoEmailPopup');

  const shouldShow = () => {
    const saved = read();
    if (!saved) return true;
    if (saved.state === 'subscribed') return false;
    return Date.now() - saved.at > QUIET_DAYS * DAY;
  };

  // Shopify's cookie banner, where the visitor's region needs one
  const cookieBannerOpen = () => {
    const banner = document.getElementById('shopify-pc__banner');
    // The banner is position: fixed, so offsetParent is always null: check its boxes instead
    if (!banner || !banner.getClientRects().length) return false;
    const style = getComputedStyle(banner);
    return style.visibility !== 'hidden' && style.opacity !== '0';
  };

  // Another drawer or panel (cart, menu, wishlist, search) is open
  const pageBusy = () => document.body.classList.contains('overflow-hidden') || !!document.querySelector('dialog[open]');

  function open() {
    const panel = dialog();
    if (!panel || panel.open) return;
    panel.showModal();
    document.body.classList.add('overflow-hidden');
  }

  function close() {
    const panel = dialog();
    if (panel && panel.open) panel.close();
  }

  function openWhenFree(tries = 0) {
    if (cookieBannerOpen() || pageBusy()) {
      if (tries < 120) setTimeout(() => openWhenFree(tries + 1), 1000);
      return;
    }
    open();
  }

  function init() {
    const panel = dialog();
    if (!panel) return;

    panel.addEventListener('close', () => {
      document.body.classList.remove('overflow-hidden');
      if (panel.dataset.state !== 'success' && !panel.hasAttribute('data-design-mode')) write('closed');
    });

    panel.addEventListener('click', (event) => {
      // the backdrop counts as a click on the dialog itself
      if (event.target === panel || event.target.closest('[data-popup-close]')) close();
    });

    // Back from Shopify's form: thank the visitor, or show the error. Every sign-up form on the page
    // gets the result, so stay closed when the footer's form sent it (its id comes back in the URL hash).
    const fromFooter = window.location.hash === '#RonsocoFooterForm';
    if (panel.dataset.state === 'success') {
      write('subscribed');
      if (!fromFooter) open();
      return;
    }
    if (panel.dataset.state === 'error') {
      if (!fromFooter) open();
      return;
    }

    if (panel.hasAttribute('data-design-mode')) return;
    if (!shouldShow()) return;

    const delay = (parseInt(panel.dataset.delay, 10) || 5) * 1000;
    setTimeout(openWhenFree, delay);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Theme editor: wire up the re-rendered section, open it while it's selected
  document.addEventListener('shopify:section:load', (event) => {
    if (event.target.querySelector('#RonsocoEmailPopup')) init();
  });
  document.addEventListener('shopify:section:select', (event) => {
    if (event.target.querySelector('#RonsocoEmailPopup')) open();
  });
  document.addEventListener('shopify:section:deselect', (event) => {
    if (event.target.querySelector('#RonsocoEmailPopup')) close();
  });

  window.ronsocoEmailPopup = { open, close };
})();
